import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {NullAsDefault} from 'views/Shared'
import {organization_getAnnouncements_Api} from "../../../apis";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import CRUD from "../../Shared/enums/CRUD";
import {formatSimplifyDate} from "../../../helpers/dateUtils";
import _ from "lodash";
import {DoubleValueItem} from "../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import usePaginationHelper, {createPagerKey} from "../../AppLocals/hooks/usePaginationHelper";
import {bindQueryParam} from "../../AppLocals/functions/routerHelper";
import WorkspaceContext from "../WorkspaceContext";
import {useLocation} from "react-use";
import {useRouteSearchParam} from "../../../envs/_current/history";
import {AnnouncementTypes} from "../../AppLocals/Organization/consts/AnnouncementTypes";
import Toggle from "../../../components/Toggle";
import {Image, Modal} from "antd";
import {useOrganizationAnnouncementApi} from "../../AppLocals/Organization/functions/useOrganizationAnnouncementApi";
import {FiChevronsRight} from "react-icons/fi";
import {HiLink, HiViewfinderCircle} from "react-icons/hi2";
import {ImagePlaceholder} from "../../../conts/imageBase64";
import classNames from "classnames";
import {TYPE_COLORS} from "../../Organization/components/OrganizationAnnouncementItem";

const WrapperDetailItem = ({title, children}) => {
    const t = useTranslate()

    return (
        <div className="flex flex-col gap-1">
            <span className="font-medium text-color-200 tracking-wide">
                {t(title)}
            </span>
            {children}
        </div>
    )
}

export const renderOrganizationAnnouncement = ({t, handleAction = NullAsDefault, organization = null, actionMenu = false}) => (item) => {

    const {organization_department,type_code, type_label, title, content, photo, time_open, time_close, shared_url, created} = item ?? {}

    const colors = TYPE_COLORS[type_code] || TYPE_COLORS.DEFAULT

    return (
        <Toggle>
            {(isToggle, toggle) => (
                <React.Fragment>
                    <div
                        key={item.id}
                        className="flex flex-col flex-1 background border border-color-50 shadow-md hover:scale-3xs rounded-xl transition duration-300">
                        <div className="px-3 py-2 flex flex-col gap-1 border-b">
                            <div className="flex flex-center gap-x-2">
                                {
                                    !!type_label ? (
                                        <>
                                            {_.find(AnnouncementTypes, {value: item?.type_code || item?.type_label})?.icon}
                                            <span style={{ color: colors?.label }} className="flex-1 font-bold tracking-wider">
                                                {type_label}
                                            </span>
                                        </>
                                    ) : (
                                        <span className="flex-1"/>
                                    )
                                }
                                {actionMenu && (
                                    <div className="flex items-center gap-x-3">
                                        <div
                                            onClick={() => {
                                                handleAction(CRUD.UPDATE, {...item, organization});
                                            }}
                                            className="font-medium text-xs text-indigo-500 hover:text-primary cursor-pointer transition duration-200">
                                            {t('edit')}
                                        </div>
                                        <div
                                            onClick={() => {
                                                handleAction(CRUD.DELETE, {...item, organization});
                                            }}
                                            className="font-medium text-xs text-red-500 hover:text-primary cursor-pointer transition duration-200">
                                            {t('delete')}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* START: Cấu trúc mới cho Tiêu đề và Nội dung */}
                        <div className="p-3 flex flex-col flex-1">
                            {photo && (
                                <Image
                                    src={photo || ImagePlaceholder}
                                    fallback={ImagePlaceholder}
                                    style={{height: 150}}
                                    className="flex flex-center object-cover rounded-t-xl"
                                    wrapperClassName="w-full object-cover rounded-t-xl rounded-b-3xs"
                                    preview={{
                                        mask: (
                                            <div className="w-full h-full relative">
                                                <HiViewfinderCircle
                                                    size={16} style={{top: 10, right: 10}}
                                                    className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                                />
                                            </div>
                                        ),
                                    }}
                                />
                            )}
                            <div className={classNames(
                                "p-2 flex flex-col background-50 shadow",
                                photo ? 'rounded-b-xl' : 'rounded-xl'
                            )}>
                                <div
                                    onClick={toggle}
                                    className="flex-1 font-bold text-sm text-gray-800 hover:text-primary max-lines-1 cursor-pointer">
                                    {title}
                                </div>
                                <div className="text-xs text-color-300 tracking-wider whitespace-pre-line max-lines-2">
                                    {content}
                                </div>
                                {_.some([time_open, time_close]) && (
                                    <DoubleValueItem
                                        showIcon={true}
                                        labelFirst="time"
                                        valueFirst={formatSimplifyDate(time_open, 'medium')}
                                        labelSecond={time_close && ' - ' || ''}
                                        valueSecond={time_close && formatSimplifyDate(time_close, 'medium')}
                                        className="my-1 text-xs italic"
                                    />
                                )}
                                {!!shared_url && (
                                    <div className="flex items-center gap-1">
                                        <HiLink size={12} className="text-blue-500"/>
                                        <a
                                            href={shared_url} target="_blank" rel="noopener noreferrer"
                                            className="flex-1 text-blue-600 italic no-underline max-lines-1">
                                            {shared_url}
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* Footer */}
                        <div className="p-3 pt-0 flex items-end justify-between gap-2">
                            <div className="flex flex-col flex-1">
                                <span className="font-bold text-secondary-600 tracking-wide">
                                    {organization_department?.title}
                                </span>
                                <p className="text-xs text-color-400 italic">
                                    {t('created on')} {formatSimplifyDate(created, 'fullTime')}
                                </p>
                            </div>
                            <span onClick={toggle}
                                  className="flex items-center gap-1 text-color-400 hover:text-color-100 cursor-pointer">
                                <span className="text-xs italic">
                                    {t('view detail')}
                                </span>
                                <FiChevronsRight size={13}/>
                            </span>
                        </div>
                    </div>
                    {isToggle && (
                        <Modal
                            width={600}
                            footer={null}
                            centered={true}
                            open={isToggle}
                            destroyOnHidden={true}
                            onCancel={toggle}>
                            <div className="flex flex-col gap-6">
                                <div className="text-center font-bold text-color-000 tracking-wide">
                                    {t('announcements')}
                                </div>
                                <div className="flex flex-col gap-3">
                                    <WrapperDetailItem title="title">
                                        <span className="ml-3 font-bold text-lg text-gray-700 tracking-wide">
                                            {title}
                                        </span>
                                        {type_label && (
                                            <span
                                                className="ml-3 font-semibold text-sm text-blue-700 italic tracking-wide">
                                                {t(type_label)}
                                            </span>
                                        )}
                                    </WrapperDetailItem>
                                    <WrapperDetailItem title="content">
                                        {photo && (
                                            <Image
                                                src={photo || ImagePlaceholder}
                                                fallback={ImagePlaceholder}
                                                // style={{height: 150}}
                                                className="flex flex-center object-cover rounded-xl"
                                                wrapperClassName="ml-3 w-full object-cover rounded-xl"
                                                preview={{
                                                    mask: (
                                                        <div className="w-full h-full relative">
                                                            <HiViewfinderCircle
                                                                size={16} style={{top: 10, right: 10}}
                                                                className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                                            />
                                                        </div>
                                                    ),
                                                }}
                                            />
                                        )}
                                        <div className="ml-3 text-color-300 tracking-wider whitespace-pre-line">
                                            {content}
                                        </div>
                                        {(time_open || time_close) && (
                                            <DoubleValueItem
                                                showIcon={true}
                                                labelFirst={t('from date')}
                                                valueFirst={formatSimplifyDate(time_open, 'medium')}
                                                labelSecond={t('to date')}
                                                valueSecond={formatSimplifyDate(time_close, 'medium')}
                                                className="ml-3 text-sm"
                                            />
                                        )}
                                        {shared_url && (
                                            <div className="flex items-center gap-1">
                                                <HiLink size={12} className="text-blue-500"/>
                                                <a
                                                    href={shared_url} target="_blank"
                                                    className="flex-1 text-sm text-blue-600 italic no-underline max-lines-1">
                                                    {shared_url}
                                                </a>
                                            </div>
                                        )}
                                    </WrapperDetailItem>
                                    <WrapperDetailItem title="send at">
                                        <span className="ml-3 text-color-300 tracking-wider italic">
                                            {formatSimplifyDate(created, 'fullTime')}
                                        </span>
                                    </WrapperDetailItem>
                                </div>
                                <div className="text-right">
                                    <span
                                        onClick={toggle} className="text-color-400 hover:text-color-100 cursor-pointer">
                                        {t('close')}
                                    </span>
                                </div>
                            </div>
                        </Modal>
                    )}
                </React.Fragment>
            )}
        </Toggle>
    )
}

const WorkspaceOrganizationAnnouncements = ({
                                                title,
                                                refreshToken,
                                                filter_actions = {
                                                    sortBy: 'sort-by',
                                                    keyword: 'keyword',
                                                },
                                            }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const location = useLocation()
    const {organization} = useContext(WorkspaceContext)
    const organizationDepartments = _.get(organization, 'organization_departments', [])

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const {
        modal,
        refresh_token,
        handleAction = NullAsDefault,
        onRefresh
    } = useOrganizationAnnouncementApi({
        organization,
        organizationDepartments: organizationDepartments,
        notifyListeners: {
            onCreated: (__, data) => {
                onRefresh()
            },
            onUpdated: (__, data) => {
                onRefresh()
            },
            onDeleted: (__, data) => {
                onRefresh()
            },
        }
    });

    const refresh_deps = useMemo(
        () => [
            refresh_token,
            refreshToken,
            organization?.id,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [refresh_token, refreshToken, organization?.id, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        isToggleDefault: true,
        AdvancedFilter: NullAsDefault,
        renderFilter: NullAsDefault,
        query_params: filter_actions,
        withKey: createPagerKey(refresh_deps),
        pagerInfo: {
            RenderEntity: React.Fragment,
            query: bindQueryParam({id: organization?.id}),
            PaginationMeta: NullAsDefault,
            apiInfo: organization_getAnnouncements_Api,
            renderItem: renderOrganizationAnnouncement({
                isLg,
                t,
                organization,
                handleAction,
                actionMenu: true
            }),
            renderWrap: (child, __, count) => !!count ? (
                <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {child}
                </div>
            ) : (
                <div className="mt-4 flex flex-col gap-6">
                    {child}
                </div>
            )
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({})
        },
        filter_params: {},
        dependencies: [],
        renderHeader: ([searchBar, filterBar]) => (
            <div className="mt-3 flex flex-col gap-3">
                {filterBar}
            </div>
        ),
    })

    return (
        <div className="min-h-screen antialiased ">
            {pager_widget}
            {modal}
        </div>
    )
}

export default WorkspaceOrganizationAnnouncements
